import { ApiRequest, patchItem } from "utils/ApiUtils";
import buildQuery from 'odata-query';
import { ProjectDetails } from 'classes';

const projects_endpoint = "/Project"


async function getProjectInfo(selectedProject) {
    const params = buildQuery({ filter: { ProjectId: { eq: { type: 'guid', value: selectedProject } } } })
    const data = await ApiRequest(projects_endpoint, params)
    return new ProjectDetails(data.value[0])
}

async function updateProjectInfo(data,projectID) {
  const params = `?projectId=${projectID}`
  const resourcePath = `${projects_endpoint}/Update`
  const result = await patchItem(resourcePath, params, data,false)
  return result
}

export { ProjectDetails, getProjectInfo, updateProjectInfo }